import type { CommercialServiceOption, ResidentialServiceOption, TimelineOption } from './quote'

/**
 * Display labels for the quote-form service and timeline enums. Single source
 * of truth for the dropdown options in `quote-client.tsx` and the SES email
 * label maps in `email.ts`. The driveway entry shows the bare label here; the
 * email decorates it with the live price-special framing at send time so the
 * dynamic figures stay out of static copy.
 */

export const residentialServiceLabels: Record<ResidentialServiceOption, string> = {
  driveway: 'Driveway restoration',
  excavation: 'Excavation / site cut',
  retaining: 'Retaining wall',
  'rock-walls': 'Rock / boulder wall',
  drainage: 'Drainage',
  landscaping: 'Landscaping',
  paths: 'Crushed rock paths',
  steps: 'Steps / stairs',
  other: 'Other',
  notsure: 'Not sure where to start',
}

export const commercialServiceLabels: Record<CommercialServiceOption, string> = {
  'site-prep': 'Site Prep for Builders',
  'subdivision-civil': 'Subdivision & Civil',
  'council-infrastructure': 'Council & Infrastructure',
  'emergency-storm': 'Emergency & Storm Work',
  'grant-ready': 'Grant-ready projects',
  'ongoing-partnership': 'Ongoing Partnership',
  other: 'Other',
}

export const timelineLabels: Record<TimelineOption, string> = {
  asap: 'ASAP / within 2 weeks',
  '1-3months': '1 to 3 months',
  '3plus': '3+ months / just planning',
}
